import classNames from 'classnames'
import dayjs from 'dayjs'

import FlickingArea from '@web/components/FlickingArea/FlickingArea'

import styles from './ProgressStamp.module.scss'
import ProgressStampItem, { ProgressStampItemProps } from './ProgressStampItem'

export type ProgressStamps = (Omit<ProgressStampItemProps, 'total' | 'number' | 'classname' | 'allowOver'> & {
  createDateTime: string
})[]

interface Props {
  total: number
  stamps: ProgressStamps
  countTitle: string
  classname?: string
  withAnimation?: boolean
  animationOrder?: number
  allowOver?: boolean
  multiple?: boolean
  isSummary?: boolean
}

const ProgressStamp = ({
  total,
  stamps,
  countTitle,
  classname,
  withAnimation = false,
  animationOrder,
  allowOver,
  multiple = false,
  isSummary,
}: Props) => {
  const single = !multiple && stamps.length === 1
  const Wrapper = single ? 'ul' : FlickingArea

  return (
    <Wrapper
      className={classNames(styles.stamp_list, styles.type_multiple, classname, { [styles.type_modal]: isSummary })}
      options={{ cameraTag: 'ul', align: 'prev' }}
      role="none"
    >
      {stamps
        .sort((a, b) => (dayjs(a.createDateTime).isAfter(dayjs(b.createDateTime)) ? -1 : 1))
        .map(({ count, title, description, image, onClick }, index) => (
          <ProgressStampItem
            key={index}
            classname={classNames({ [styles.type_horizontal]: single })}
            {...{
              countTitle,
              count,
              title,
              description,
              image,
              onClick,
              number: index,
              total,
            }}
            withAnimation={withAnimation}
            animationOrder={animationOrder}
            allowOver={!!allowOver}
          />
        ))}
    </Wrapper>
  )
}

export default ProgressStamp
